import { render, staticRenderFns } from "./articleSearch.vue?vue&type=template&id=ba81df32&scoped=true"
import script from "./articleSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./articleSearch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./articleSearch.vue?vue&type=style&index=0&id=ba81df32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba81df32",
  null
  
)

export default component.exports